import { render, staticRenderFns } from "./CreateCartographyCourse.vue?vue&type=template&id=50e4991b&scoped=true"
import script from "./CreateCartographyCourse.vue?vue&type=script&lang=js"
export * from "./CreateCartographyCourse.vue?vue&type=script&lang=js"
import style0 from "./CreateCartographyCourse.vue?vue&type=style&index=0&id=50e4991b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4991b",
  null
  
)

export default component.exports